export default "__VITE_ASSET__5c23c916__"